import React, { useEffect, useState } from "react";
import ReactFlow, { Controls, Background } from "react-flow-renderer";
import flowchartData from "./data/dummy.json";
import "../css/flowchart.css";
import { Divider, Typography, Button } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import LoadingCustomButton from "../components/LoadingCustomButton";
import Flowchart from "../components/Flowchart";
import { useNavigate, useLocation } from "react-router-dom";
import FlowchartSummaryModal from "../components/FlowchartSummaryModal";

const Diagnose = () => {
   const [selectedNodes, setSelectedNodes]: any = useState([]);
   const _useLocation: any = useLocation();
   const [disabled, setDisabled] = useState(true);
   const [flowchartId, setFlowchartId] = useState();
   const [openSummaryModal, setOpenSummaryModal] = useState(false);

   const [expanded, setExpanded] = React.useState<string | false>(false);
   const navigate = useNavigate();

   useEffect(() => {
      if (!_useLocation.state || !disease_id) {
         navigate("/home");
      }
   });

   const disease_id = _useLocation.state?.disease_id;

   useEffect(() => {
      if (selectedNodes[0]) {
         window.onbeforeunload = () => true;
      } else {
         window.onbeforeunload = null;
      }
   }, [selectedNodes]);

   return (
      <>
         <div className="flowchart-screen-container">
            <div className="preview-container">
               <div className="wrapper">
                  {/* <div className="extra-question">
       <Typography className="heading">Question</Typography>
       <Typography className="question">
          What is the question?
       </Typography>
       <Typography className="option">Option 1</Typography>
       <Typography className="option">Option 2</Typography>
       <Typography className="option">Option 3</Typography>
       <LoadingCustomButton
          variant="contained"
          loading={false}
          className="submit-btn"
       >
          <Typography className="name">Submit</Typography>
       </LoadingCustomButton>
    </div>
    <Divider /> */}
                  <div className="summary-preview-container">
                     <Typography className="heading">
                        Community Acquired Pneumonia
                     </Typography>
                     <Divider />
                     <Typography className="sub-heading">
                        Decision Summary
                     </Typography>
                     {selectedNodes.map((data: any, index: number) => (
                        <div className="data-container" key={index}>
                           <div
                              className="label-container"
                              onClick={() => {
                                 setExpanded(
                                    expanded === data.id ? false : data.id
                                 );
                              }}
                           >
                              <span className="icon-container">
                                 {/* <Check className="icon" /> */}
                              </span>
                              <span
                                 style={{
                                    display: "flex",
                                    flex: 1,
                                    marginLeft: "10px",
                                    flexDirection: "column",
                                 }}
                              >
                                 {data.data.label
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Typography
                                          className="label"
                                          key={index}
                                       >
                                          {ele}
                                       </Typography>
                                    ))}
                              </span>
                              {expanded === data.id ? (
                                 <ExpandLess />
                              ) : (
                                 <ExpandMore />
                              )}
                           </div>
                           {expanded === data.id ? (
                              <div className="description-container">
                                 {/* <Typography className="description">
                                    {data.data.description}
                                 </Typography> */}
                                 {data.data.description
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Typography
                                          className="description"
                                          key={index}
                                       >
                                          {ele}
                                       </Typography>
                                    ))}
                              </div>
                           ) : null}
                        </div>
                     ))}
                  </div>
               </div>
               <LoadingCustomButton
                  variant="contained"
                  loading={false}
                  className="preview-btn"
                  disabled={disabled}
                  onClick={() => setOpenSummaryModal(true)}
               >
                  <Typography className="name">Preview</Typography>
               </LoadingCustomButton>
               <FlowchartSummaryModal
                  open={openSummaryModal}
                  close={() => setOpenSummaryModal(false)}
                  selectedNodes={selectedNodes}
                  flowchartId={flowchartId}
                  disease_id={disease_id}
               />
            </div>
            <Flowchart
               expanded={expanded}
               selectedNodes={selectedNodes}
               setExpanded={setExpanded}
               setSelectedNodes={setSelectedNodes}
               disease_id={disease_id}
               setPrvDisabled={setDisabled}
               setFlowchartId={setFlowchartId}
            />
         </div>
      </>
   );
};

export default Diagnose;
